<script lang="ts">
import Vue from "vue";
import { Getter } from "vuex-class";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";

import AuditsResourceApi from "@/lib/apis/replicable/operations/AuditsResourceApi";
import { AuditRepresentation } from "@/lib/apis/replicable/models";

import { Modal as NekoModal } from "@/components/modal";

@Component({
	components: {
		NekoModal
	}
})
export default class MultipleAuditNotifier extends Vue {
	@Prop({ default: 1})
	public readonly countRequired!: number;

	@Ref()
	private readonly modal!: NekoModal;

	@Getter("context/audit")
	private readonly audit!: AuditRepresentation;

	public countAudits: number = 0;

	private mounted() {
		this.refreshAudits()
	}

	@Watch("audit.auditorId")
	private async refreshAudits() {
		this.countAudits = (await AuditsResourceApi.assignToMeNotFinished({}, "none")).length;

		if (this.countAudits > this.countRequired) {
			this.modal.show();
		}
	}
}
</script>

<template>
	<neko-modal ref="modal">
		<template #title>
			<p>{{ $t("modal.title") }}</p>
		</template>
		<template #default>
			<div class="content">
				<p v-html="$t('modal.description1', { count: countAudits })"></p>
				<p>{{ $t("modal.description2") }}</p>
			</div>
		</template>
	</neko-modal>
</template>

<i18n>
{
	"fr": {
		"modal.title": "Avertissement multi audit",
		"modal.description1": "Vous êtes en train de réaliser une action qui pourrait entraîner une multitude d'audit en cours. Actuellement <strong>{count}</strong> audits sont en cours.",
		"modal.description2": "Cette fenêtre ne vous empêchera pas d'effectuer votre action. Elle vous notifie seulement que vous avez plusieurs audits en cours ou qui ne sont pas clotûrés."
	}
}
</i18n>
